import ReactPaginate from "react-paginate";

const SearchPager = ({ total, offset, amount, handleUpdateOffset }) => {
  const totalPages = total / amount;

  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = (i) => {
    const searchResults = document.querySelector(".search-page-wrapper");

    handleUpdateOffset(i.selected * amount);

    if (searchResults) {
      searchResults.scrollIntoView({
        block: "start",
      });
    }
  };

  return (
    <div className="pager">
      <ReactPaginate
        pageCount={totalPages}
        pageRangeDisplayed={5}
        marginPagesDisplayed={1}
        onPageChange={handlePageChange}
        containerClassName="pager__items"
        activeClassName="is-active"
        pageClassName="pager__item"
        pageLinkClassName="pager__link"
        previousClassName="pager__item pager__item--previous"
        previousLinkClassName=""
        previousLabel="‹ Vorige"
        nextClassName="pager__item pager__item--next"
        nextLinkClassName=""
        nextLabel="Volgende ›"
        forcePage={offset / amount}
      />
    </div>
  );
};

export default SearchPager;
